import { StyleSheet } from 'react-native'
import { Button, ButtonProps, Spacing, ToastStatus } from 'zens-storybook'
import { observable, runInAction } from 'mobx'

import { Store } from '../general'

const styles = StyleSheet.create({
  button: {
    marginLeft: Spacing?.S,
  },
})

export interface Message {
  id: number
  message: string
  status?: ToastStatus
  closeable?: boolean
  timeout?: number
  button?: ButtonProps
}

class MessageStore extends Store {
  private data = observable<Message>([])
  private timers: Record<string, NodeJS.Timeout> = {}

  get all() {
    const messages = this.data.slice()
    return messages.map((item) => {
      const { button, ...otherItem } = item
      return {
        ...otherItem,
        ...(button ? { right: <Button {...button} style={[button.style, styles.button]} /> } : {}),
      }
    })
  }

  add = (message: Omit<Message, 'id'> & { id?: number }) => {
    const newMessage = { ...message, id: message.id || Date.now() }
    const { id } = newMessage
    runInAction(() => {
      this.data.push(newMessage)
    })
    if (message?.timeout !== 0) {
      this.timers[`${id}`] = setTimeout(() => {
        this.remove(id)
      }, message.timeout || 3000)
    }
  }

  remove = (id: number) => {
    const message = this.data.find((item) => item.id === id)
    if (!message) return
    runInAction(() => {
      this.data.remove(message)
    })
    if (this.timers[`${id}`]) {
      clearTimeout(this.timers[`${id}`])
      delete this.timers[`${id}`]
    }
  }
}

export default MessageStore
